var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1535 6.72302C14.1535 6.72302 13.6768 12.789 13.4081 15.336C13.3922 15.8699 13.1738 16.3757 12.8004 16.7432C12.427 17.1107 11.9289 17.3101 11.4146 17.298H11.3626C9.1004 17.298 6.83823 17.343 4.57604 17.298C4.07085 17.3151 3.57965 17.1241 3.20949 16.7667C2.83932 16.4093 2.62019 15.9145 2.59988 15.39C2.32252 12.816 1.85449 6.76807 1.85449 6.76807",
    stroke: "#008AFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3498 3.81604H0.615234",
    stroke: "#008AFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5158 3.81604C12.1867 3.81636 11.8677 3.69805 11.6133 3.4814C11.3588 3.26475 11.1846 2.96312 11.1203 2.62798L10.9037 1.53001C10.8422 1.28503 10.7042 1.0682 10.5113 0.913456C10.3183 0.758714 10.0814 0.674858 9.83759 0.675053H6.17127C5.92637 0.674403 5.68814 0.757918 5.49373 0.912577C5.29933 1.06724 5.15966 1.2843 5.09652 1.53001L4.87984 2.62798C4.81563 2.96312 4.64141 3.26475 4.38693 3.4814C4.13245 3.69805 3.81345 3.81636 3.48438 3.81604",
    stroke: "#008AFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBlue);
export default __webpack_public_path__ + "static/media/trash-blue.3903d424f6d8c7b5aa84dcb6beb99f83.svg";
export { ForwardRef as ReactComponent };